import { NotificationAnimationType } from '../enums/notification-animation-type.enum';
import { Options, Position } from '../interfaces/options.type';

export const DEFAULT_OPTIONS: Options = {
    position: ['top', 'right'] as Position,
    timeOut: 5500,
    animate: NotificationAnimationType.FromRight,
    showProgressBar: true,
    lastOnBottom: false,
};
